const WarehouseLocation = `
  id
  description
  capacity
  siteId
`;

export default WarehouseLocation;
